import slick from 'slick-carousel';
import imgLiquid from 'plugs/imgLiquid-min.js';
import 'plugs/jquery.easing.1.3.js';
import 'plugs/svg.js';


var $window = $(window);
var winW, winH, footerH, bodyH, scrollTop;
$(function () {
    $('body').addClass('fade-in');
    $("#topBtn").click(function () {
        $("html,body").animate({ scrollTop: 0 }, 1000, 'easeOutExpo');
        return false;
    });
    //menu active mode(select this)
    if ($('main.about').length > 0) {
        $('ul.mmenu > li.about').addClass('active');
    } else if ($('main.product').length > 0) {
        $('ul.mmenu > li.product').addClass('active');
    } else if ($('main.service').length > 0) {
        $('ul.mmenu > li.service').addClass('active');
    } else if ($('main.news').length > 0) {
        $('ul.mmenu > li.news').addClass('active');
    } else if ($('main.contact').length > 0) {
        $('ul.mmenu > li.contact').addClass('active');
    } else if ($('main.pdf').length > 0) {
        $('ul.mmenu > li.pdf').addClass('active');
    } else if ($('main.custom').length > 0) {
        $('ul.mmenu > li.custom').addClass('active');
    }
    //mobile menu
    var menuicon = $('header .menuicon'),
        navBox = $('header .mmenu'),
        nav = $('header .navBox'),
        $body = $('body'),
        $header = $('header');
    menuicon.on('click', function () {
        var $this = $(this);
        if (!$header.hasClass('menu-expanded')) {
            $header.addClass('menu-expanded');
            nav.stop().fadeIn();
            $body.css({ 'overflow': 'hidden' }).addClass('modal_open');
        } else {
            $header.removeClass('menu-expanded');
            nav.stop().fadeOut(function () { $(this).removeAttr('style'); });
            $body.css({ 'overflow': '' }).removeClass('modal_open');
        }
        return false;
    });
    //scroll animation
    var win_height_padded = $window.height() * 0.9;
    window.setTimeout(function () {
        $window.on('scroll', revealOnScroll);
        revealOnScroll();
    }, 200);
    var old_w;
    $window.on('resize', function () {
        winW = $window.width();
        winH = $window.height();

        footerH = $('footer').outerHeight(true);
        bodyH = winH - footerH;
        //bodyH
        $('main').css('min-height', bodyH);
        if (winW > 991) {
            $header.removeClass('menu-expanded');
            $('.navBox').removeAttr('style');
            nav.stop().fadeOut(function () { $(this).removeAttr('style'); });
            $body.css({ 'overflow': '' });
        }
        //background-image
        resizeBgcover(winW);
        //top menu
        if ($('#top-menu-ul').length > 0) {
            if (old_w != winW) {
                var menu_ul = $('#top-menu-ul ul').width();
                var menu_box = $('#top-menu-ul .item_menu_Box').width()

                $('#top-menu-ul').removeClass('open_flexslider');
                $('#top-menu-ul .slides').removeAttr('style');
                $('#top-menu-ul .item_menu_Box').removeAttr('style');

                if (menu_ul > menu_box) {
                    $('#top-menu-ul').addClass('open_flexslider');
                    var m_menubox = $('.item_menu_Box').width();
                    var m_start = $('.item_menu_list li:nth-child(1)').width();

                    var m_end = $('.item_menu_list li:last-child').width();
                    $('.item_menu_list').css({
                        'padding-left': (m_menubox - m_start) / 2,
                        'padding-right': (m_menubox - m_end) / 2,
                    })
                }
                slider_ul_list();
            }
            old_w = winW;
        }

    }).resize();
    $window.on('scroll', function () {
        scrollTop = $(this).scrollTop();
        gotopfun(scrollTop);
    }).scroll();

    // search btn
    $('#searchbtn').on('click', function (e) {
        $('.searchbox').toggleClass('active')
    })
    $('.mmenu').on('mouseenter', function () {
        $('.searchbox').removeClass('active')
    })
    $('.searchbox').on('click', function (e) {
        e.stopPropagation()
    })
    //product 下拉
    $('li.product').hover(function () {
        $('li.product .submenu').addClass('active')
    }, function () {
        $('li.product .submenu').removeClass('active')
    })

    //slick template
    $('.slider-banner').on('init', function (event, slick) {
        setTimeout(function () {
            $('.slickbox .rectbx').removeClass('slickinit');
        }, 3000);

    });
    $('.slider-banner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.slickbox .rectbx').addClass('on_change');
    });
    $('.slider-banner').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        $('.slickbox .rectbx').removeClass('on_change');
    });
    $('.slider-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 2500,
        fade: true,
        arrows: false,
        dots: true,
        customPaging: function (slider, i) {
            i = i + 1;
            var current = (i < 10) ? "0" + i : i;
            return current + '<span></span>';
        },
    });
    var count = $('.slider-brand .bx').length;
    if (count < 5 && count > 1) {
        $(".slider-brand .bx").clone().prependTo($(".slider-brand"));
        $(".slider-brand .bx").clone().prependTo($(".slider-brand"));
    } else if (count == 1) {
        $(".slider-brand .bx").clone().prependTo($(".slider-brand"));
        $(".slider-brand .bx").clone().prependTo($(".slider-brand"));
        $(".slider-brand .bx").clone().prependTo($(".slider-brand"));
    }
    $('.slider-brand').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        pauseOnHover: false,
        speed: 1500,
        arrows: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    });
    $('.indx-brand .btn-slick-prev').click(function () {
        $('.slider-brand').slick("slickPrev");
    });
    $('.indx-brand .btn-slick-next').click(function () {
        $('.slider-brand').slick("slickNext");
    });
});

//搜尋功能
let searchbtn = document.getElementById("search-btn")
searchbtn.addEventListener('click', function () {
    let kw = document.querySelector('.search-val').value;
    location.href = "product.php?kw=" + kw;
})
document.querySelector('.search-val').addEventListener("keypress", function (event) {
    let kw = document.querySelector('.search-val').value;
    if (event.keyCode === 13) {
        location.href = "product.php?kw=" + kw;
    }
})
